"use strict";

export default {
	"production": {
		"services": {
			"sparxpres": {
				"uri": "https://sparxpres.dk/",
				"endpoints": {
					"calculator": "app/loancalc/",
					"loanInfo": "app/loaninfo/",
					"information": "app/webintegration/info/",
					"xprespay": "app/xprespay/info/"
				}
			},
		},
		"externalPages": {
			"checkout": "https://sparxpres.dk/ansoegning/init/",
		},
		"processers": {
			"enabled": [
				"general", // general should always be loaded before information, since information might depend on html from general (when opening information in modal)
				"information", // information should always be loaded before (product and cart), since (product and cart) might depend on html from information (when opening information in modal), since they should be able to open the information modal.
				"product",
				"cart",
				"checkout"
			]
		},
		"consts": {
			"PAGES": {
				"INFORMATION": "information",
				"PRODUCT": "product",
				"CART": "cart",
				"GENERAL": "general",
				"CHECKOUT": "checkout"
			}
		}
	}
}
